<template>
  <!-- まとめ買い一覧テーブル -->
  <div class="bg-white shadow overflow-hidden sm:rounded-md">
    <ul class="divide-y divide-gray-200">
      <li
        v-if="pagination.data.length === 0"
        class="px-6 py-4">
        <p class="text-gray-500 text-center">まとめ買いがありません</p>
      </li>
      <li
        v-for="bulkPurchase in pagination.data"
        :key="bulkPurchase.id"
        class="px-6 py-4 hover:bg-gray-50 cursor-pointer"
        @click="onBulkPurchaseClick(bulkPurchase)">
        <div class="flex items-start justify-between mb-2">
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-medium text-gray-900 truncate">
                {{ bulkPurchase.title }}
              </h3>
              <div class="text-lg font-semibold text-gray-900">
                ¥{{ formatPrice(bulkPurchase.price) }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <!-- 含まれる模試一覧 -->
          <div class="mt-3">
            <p class="text-sm font-medium text-gray-700 mb-2">
              含まれる模試:
              <span v-if="bulkPurchase.examinations && bulkPurchase.examinations.length > 0">
                {{ bulkPurchase.examinations[0].title }}
                <span v-if="bulkPurchase.examinations.length > 1">
                  他{{ bulkPurchase.examinations.length - 1 }}件
                </span>
              </span>
              <span
                v-else
                class="text-gray-500">模試が設定されていません</span>
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <!-- ページネーション -->
  <div class="mb-5 pb-5">
    <div class="mt-4">
      <pagination
        :paginate="pagination"
        @page-previous="onPaginationChanged"
        @page-next="onPaginationChanged"
        @page-click="onPaginationChanged" />
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import formatPrice from '@/actions/format/formatPrice'
import Pagination from '../../../../Common/Pagination'

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  limit: {
    type: String,
    default: '15',
  },
  currentExaminationId: {
    type: String,
    default: '',
  },
  currentExaminationType: {
    type: String,
    default: '',
  },
})

const onPaginationChanged = (page) => {
  Inertia.get(route('bulk_purchase.index', {
    page,
    limit: props.limit,
    examinationId: props.currentExaminationId,
    examinationType: props.currentExaminationType,
  }))
}
''
const onBulkPurchaseClick = (bulkPurchase) => {
  Inertia.get(route('bulk_purchase.show', {
    bulkPurchaseId: bulkPurchase.id,
    limit: props.limit,
    examinationId: props.currentExaminationId,
    examinationType: props.currentExaminationType,
  }))
}
</script>
